import { DOM } from '@app/utils';
import { createSelector } from 'reselect';
import { CurrencyCode } from '@app/types/generated';
import type { RootState } from '../types';

export const getCurrency = ({
  currency = { currency: null, locale: '' },
}: RootState) => currency;

export const getSelectedCurrency = createSelector(
  getCurrency,
  ({ currency }) => {
    if (currency) {
      return currency;
    }

    return (
      DOM.getCookie<CurrencyCode>('stockx_selected_currency') ||
      CurrencyCode.USD
    );
  },
);

export const getCurrencies = createSelector(
  getCurrency,
  ({ currencies = {} }) => currencies,
);

export const getSelectedCurrencyObject = createSelector(
  [getSelectedCurrency, getCurrencies],
  (currency, currencies) => currencies[currency] || {},
);

export const getSelectedCurrencySymbol = createSelector(
  [getSelectedCurrencyObject],
  ({ symbol }) => symbol || '',
);

export const getCurrencyIncrement = createSelector(
  [getSelectedCurrencyObject],
  ({ increment }) => increment || 1,
);

export const getLocale = createSelector(getCurrency, ({ locale }) => locale);

export const shouldRoundCurrency = (currency: string) =>
  currency === 'JPY' || currency === 'KRW';

export const getShouldRoundCurrency = createSelector(
  getSelectedCurrency,
  (currency) => shouldRoundCurrency(currency),
);
